import { PageVisibleState } from '../../metric/base-metric';
import {
	type BaseMetricDataWithStartAndStop,
	type BasePageLoadMetricDataWithStartAndStop,
	PageVisibleValueOrigin,
	type PerformanceEventConfig,
	type ShareableGlobalConfig,
} from '../../types';

export const pageVisibleValue = (
	_config: PerformanceEventConfig,
	data: BaseMetricDataWithStartAndStop | BasePageLoadMetricDataWithStartAndStop,
	globalConfig: ShareableGlobalConfig,
): {
	'pageVisible:value': boolean;
} => {
	const value =
		globalConfig.pageVisibleValueOrigin === PageVisibleValueOrigin.documentHidden
			? !document.hidden || false
			: data.pageVisibleState === PageVisibleState.VISIBLE;
	return {
		'pageVisible:value': value,
	};
};
